// extracted by mini-css-extract-plugin
export default {"activeKpi":"src-views-analytics-components-ProfileKPI-ProfileKPI__activeKpi--ZjIun","kpiTab":"src-views-analytics-components-ProfileKPI-ProfileKPI__kpiTab--qrA0F"};